import React, { useState } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { SortBarStyles } from './SortBar.styled';
import ChevronDown from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-dwn.svg';

const AnchoredModal = dynamic(
  () => import('@components/Shared/Modal/AnchoredModal/AnchoredModal'),
  { ssr: false }
);

const DropDownList = dynamic(
  () => import('@components/Shared/DropDownList/DropDownList'),
  {
    ssr: false,
  }
);

const SortBar = ({ numResults, onSort, sortId, defaultSortId }) => {
  const sortOptions = [
    { value: 2, text: 'HIGHEST PRICE' },
    { value: 3, text: 'LOWEST PRICE' },
    { value: 1, text: 'HOMES IN STOCK' },
    { value: 4, text: 'FEATURED' },
  ];

  const [newSortId, setNewSortId] = useState(sortId);
  const [sortModalShowing, setSortModalShowing] = useState(false);
  const [sortItem, setSortItem] = useState(
    sortOptions.find((itm) => itm.value === sortId)
  );

  const onClose = () => {
    setSortItem(sortOptions.find((itm) => itm.value === sortId));
  };

  return (
    <SortBarStyles sortText={sortItem.text}>
      <div className="num-results">
        <p className="label large">Results: {numResults}</p>
      </div>

      <div className="sort-opt-container">
        <p className="sort-options-label label large"> Sort By: </p>
        <span className="sort-by">
          <button
            suppressHydrationWarning={true}
            title="Sort By"
            className={
              'sort-button standard ' + (sortModalShowing ? 'active' : '')
            }
            onClick={() => {
              setSortModalShowing(!sortModalShowing);
            }}
          >
            <ChevronDown className="sorting-by-chevron" />
          </button>

          {sortModalShowing && (
            <AnchoredModal
              clearButtonClassName="filters-clear-button"
              automationId="sort-by"
              applyButtonClassName="gtm-sort-by-apply"
              onApplyButtonClick={() => {
                if (onSort && newSortId !== sortId) {
                  onSort(newSortId);
                }
                setSortModalShowing(false);
              }}
              onClearButtonClick={() => {
                if (onSort && newSortId !== defaultSortId) {
                  onSort(defaultSortId);
                  setNewSortId(defaultSortId);
                  setSortItem(
                    sortOptions.find((itm) => itm.value === defaultSortId)
                  );
                }
                setSortModalShowing(false);
              }}
              showOverflow={true}
              onCloseClick={() => {
                onClose(), setSortModalShowing(false);
              }}
            >
              <div className="sort-options">
                <DropDownList
                  automationId="sort-by-click"
                  id="sort-by-dropdown"
                  dropDownStyle="compact"
                  onChange={(value) => {
                    setNewSortId(value.value);
                    setSortItem(value);
                  }}
                  items={sortOptions}
                  selectedItem={sortItem}
                />
              </div>
            </AnchoredModal>
          )}
        </span>
      </div>
    </SortBarStyles>
  );
};

SortBar.propTypes = {
  defaultSortId: PropTypes.any,
  numResults: PropTypes.any,
  onSort: PropTypes.func,
  sortId: PropTypes.any,
};

export default SortBar;
